export default __webpack_public_path__ + "static/media/list_main_5_1.a0e080d6.png";